import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import 'react-toastify/dist/ReactToastify.css';
import App from './App';
import * as Sentry from '@sentry/react';
import './i18n';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DNS,
  integrations: [],
  environment: import.meta.env.VITE_ENV || 'development',
  enabled: ['sandbox', 'staging', 'production'].includes(
    import.meta.env.VITE_ENV as string
  ),
});

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
